import React, { Component } from 'react';
import { CashierPaymentsWidgetLazy } from '@wix/cashier-payments-widget/lazy';
import { setCashierApi, setWidgetLoaded } from '../../utils/cashierApi';
import styles from './CashierWidget.scss';
import classNames from 'classnames';
import { Loader } from 'wix-style-react';

export default class CashierWidget extends Component {
  state = { isLoading: true };

  render() {
    const {
      instance,
      language,
      singlePaymentMethod,
      mandatoryFields,
      mandatoryFieldsPrefilled,
      displayNone,
    } = this.props;

    const configuration = {
      appId: instance.appDefId,
      appInstanceId: instance.instanceId,
      msid: instance.metaSiteId,
      visitorId: instance.aid,
      locale: language,
    };

    const cashierWidget = (
      <CashierPaymentsWidgetLazy
        ref={widgetRef => {
          if (widgetRef) {
            setCashierApi(widgetRef.getApi());
          }
        }}
        locale={language}
        host="https://www.wix.com/"
        deviceType="desktop"
        configuration={configuration}
        externalSubmitButton
        allowManualPayment
        shouldApplySiteStyles={false}
        creditCardPaymentInNewTab={false}
        singlePaymentMethod={singlePaymentMethod}
        mandatoryFields={mandatoryFields}
        mandatoryFieldsPrefilled={mandatoryFieldsPrefilled}
        onFullLoad={() => {
          setWidgetLoaded();
          this.setState({ isLoading: false });
        }}
      />
    );

    const loader = (
      <div className={styles.loader}>
        <Loader size="small" />
      </div>
    );

    const className = classNames({
      [styles.hidden]: this.state.isLoading,
      [styles.displayNone]: displayNone,
    });

    return (
      <React.Fragment>
        {!displayNone && this.state.isLoading && loader}
        <div className={className}>{cashierWidget}</div>
      </React.Fragment>
    );
  }
}
